import CustomContainer from "../../components/common/CustomContainer"
import styles from "../../assets/styles/appointments.module.css"
import callNowImg from "../../assets/images/common/callnow.png"
import bookNowImg from "../../assets/images/common/booknow.png"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { callEndByPatientApi, disconnectReasonApi, getConnectTokenApi, getTalkToDoctorApi } from "../../utils/api/services"
import { toast } from "react-toastify"
import { setAuthConnectToken } from "../../utils/store/auth/AuthSlice"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch, RootState } from "../../utils/store"
import ConfirmModal from "../../components/common/ConfirmModal"
import UpdateProfileModal from "../../components/chat/UpdateProfileModal"
import { allergiesReducer, healthProblemsReducer, MedicationsReducer, symptomsReducer } from "../../utils/store/profile/ProfileSlice"
import useSocket from "../../utils/functions/useSocket"

const TalkToDoctor = () => {
    const [openConfirmModal, setOpenConfirmModal] = useState(false)
    const [btnLoading, setBtnLoading] = useState(false)
    const [openProfileModal, setOpenProfileModal] = useState(false)
    const [regenerateCallModal, setRegenerateCallModal] = useState(false)
    const [inProcessPatientCallData, setinProcessPatientCallData] = useState<inProcessPatientCallDataType | null>(null)
    const { sendMessage,connect, disconnect, } = useSocket();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>()
    const { LoginData } = useSelector((state: RootState) => state.auth)

  useEffect(() => {
    connect();
    return () => {
      disconnect();
    };
  }, [connect, disconnect]);

    const closeProfileModal = () => {
        setOpenProfileModal(false)
        handleCallNow();
    }

    const ConfirmUpdateProfile = async () => {
        handleCallNow();
    }

    const handleCallNow = async () => {
        try {
            const sendData = {
                "uuid": LoginData?.uuid,
                "role": "patient-app"
            }
            const result = await getConnectTokenApi(sendData);
            if (result?.access_token) {
                dispatch(setAuthConnectToken(result?.access_token))
                // navigate('/CallNow')
                window.open('/CallNow', '_blank');
            }
        } catch (error: any) {
            toast.error(error?.data?.errors || error?.message);
        }
    }

    const CloseConfirmModal = () => {
        setOpenConfirmModal(false)
    }
    const CloseRegenerateCallModalModal = () => {
        setRegenerateCallModal(false)
    }
    const DontWantToChange = () => {
        setOpenConfirmModal(false)
        handleCallNow();
    }
    const confirmSubmit = () => {
        setOpenProfileModal(true)
        setOpenConfirmModal(false)
        dispatch(MedicationsReducer({ path: 'medications' }));
        dispatch(healthProblemsReducer({ path: 'healthProblems' }));
        dispatch(symptomsReducer({ path: 'symptoms' }));
        dispatch(allergiesReducer({ path: 'allergies' }));
    }

    const handleCallNowClick = async () => {
        try {
            const result = await getTalkToDoctorApi();
            if (result?.success) {
                const inProcessPatientData = result?.response?.inProcessPatientData;
                if (inProcessPatientData?.status === 'In progress') {
                    setinProcessPatientCallData(inProcessPatientData)
                    setRegenerateCallModal(true)
                }
                else {
                    setOpenConfirmModal(true)
                }
            } else {
                toast.error(result?.message)
            }
        } catch (error: any) {
            toast.error(error?.data?.errors || error?.message);
        }
    }


    const fetchCallEnd = async (data: { callid: number | null }) => {
        try {
            await callEndByPatientApi(data);
        } catch (error: any) {
            toast.error(error?.data?.status_message || error?.message);
        }
    };

    const fetchDisconnectReason = async (data: { sessionId: string; reason: string }) => {
        try {
            await disconnectReasonApi(data);
        } catch (error: any) {
            toast.error(error?.data?.status_message || error?.message);
        }
    };
    const ConfirmRegenerateCall = async () => {
        try {
            if (inProcessPatientCallData) {
                fetchCallEnd({ callid: inProcessPatientCallData?.call_id });
                fetchDisconnectReason({ sessionId: inProcessPatientCallData?.session, reason: "clientDisconnected" });
                await sendMessage('declinefromPatient', { doctorId: inProcessPatientCallData?.doctorId, patientId: LoginData?.loggedPatientId, connectDocId: inProcessPatientCallData?.connectedDocId })
                setRegenerateCallModal(false)
                setOpenConfirmModal(true)
            }
            else {
                setRegenerateCallModal(false)
                setOpenConfirmModal(true)
            }
        } catch (error) {
            setRegenerateCallModal(false)
            setOpenConfirmModal(true)
        }
    }

    return (
        <CustomContainer>
            <div className={'AllPageMain'}>
                <div className={'HeadAndButton'}>
                    <h2>Talk to Doctor</h2>
                </div>
                <div className={styles.TalkToDoctorMain}>
                    <div className="grid grid-cols-1 md:grid-cols-2 md:gap-10 gap-y-6">
                        <div className={styles.talkTODocBox} onClick={handleCallNowClick}>
                            <img src={callNowImg} alt="call now" />
                            <h3>Call Now</h3>
                            <p>Talk to the expert doctor right now</p>
                        </div>
                        <div className={styles.talkTODocBox} onClick={() => navigate('/MyAppointments/book')}>
                            <img src={bookNowImg} alt="book now" />
                            <h3>Book an Appointment</h3>
                            <p>Schedule a online consultation with the specialist doctor</p>
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmModal
                openConfirmModal={openConfirmModal}
                CloseConfirmModal={CloseConfirmModal}
                confirmSubmit={confirmSubmit}
                DontWantToChange={DontWantToChange}
                btnLoading={btnLoading}
                title={`Do you want to update your profile?`}
            />
            {
                openProfileModal &&
                <UpdateProfileModal
                    openProfileModal={openProfileModal}
                    setOpenProfileModal={setOpenProfileModal}
                    btnLoading={btnLoading}
                    closeProfileModal={closeProfileModal}
                    ConfirmUpdateProfile={ConfirmUpdateProfile}
                />
            }
            {
                regenerateCallModal &&
                <ConfirmModal
                    openConfirmModal={regenerateCallModal}
                    CloseConfirmModal={CloseRegenerateCallModalModal}
                    confirmSubmit={ConfirmRegenerateCall}
                    DontWantToChange={CloseRegenerateCallModalModal}
                    btnLoading={btnLoading}
                    title={`You are already in a call. If you proceed, a new call will be generated, and the current call will end. Do you want to continue?`}
                />
            }
        </CustomContainer>
    )
}

export default TalkToDoctor